import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { apiProviders } from './api.provider';
import { repositoryProviders } from './repository.provider';
export var FileStorageRepositoryWebModule = /*#__PURE__*/function () {
  function FileStorageRepositoryWebModule() {
    _classCallCheck(this, FileStorageRepositoryWebModule);
  }

  _createClass(FileStorageRepositoryWebModule, null, [{
    key: "register",
    value: function register(config) {
      return {
        module: FileStorageRepositoryWebModule,
        providers: [{
          provide: 'FILE_STORAGE_REPOSITORY_WEB_CONFIG',
          useValue: config
        }].concat(_toConsumableArray(apiProviders), _toConsumableArray(repositoryProviders)),
        exports: _toConsumableArray(repositoryProviders)
      };
    }
  }]);

  return FileStorageRepositoryWebModule;
}();